import { CamelCaseKeys } from '@uplift/types';
import { restClient } from '../../client';
import { BaseResponse, User } from '../../resources';

export type FeatureFlagName = (
  | 'monthlyView'
  | 'optional_2fa_for_users'
  | 'zoc_doc'
  | 'HIGHER_ED_MVP'
  | 'PDF_GENERATE'
  | 'PROVIDER_FINANCE_PAGE'
  | 'ONBOARDING_WELCOME_STEP_AB_TEST'
  | 'IN_APP_MESSAGING'
  | 'USER_PUBLIC_ICS_SUBSCRIPTION'
  | 'SALESFORCE_CREDENTIALING_ENABLED'
  | 'PROVIDER_DOCUMENT_CENTER'
  | 'betterhelp_sso'
  | 'WALLET_PAYMENT_ENABLED'
);


export const getFeatureFlags = async (checkImpersonated: boolean) =>
  restClient.rawRequest<{ data: Record<FeatureFlagName, boolean> }>('/api/v1/feature_flags', {
    params: {
      check_impersonated: checkImpersonated
    }
  });

export type FeatureFlagRecord = CamelCaseKeys<{
  id: string;
  flag_name: FeatureFlagName;
  active: boolean;
  created_at: string;
  updated_at: string;
}>;


export const adminGetFeatureFlagsList = async () =>
  restClient.request<{
    data: FeatureFlag[];
  }>('/api/v1/admin/feature_flags');


type FeatureFlag = {
  id: string;
  flag_name: FeatureFlagName;
  active: boolean;
  created_at: string;
  updated_at: string;
};

export const adminUpdateFeatureFlag = async (flagId: string, active: boolean) =>
  restClient.request<{
    data: FeatureFlag[];
  }>(`/api/v1/admin/feature_flags/${flagId}`, { method: 'PATCH', data: { active: active } });

export type UserFlagResponse = {
  user: User;
  active: boolean;
};

export const adminGetUsersWithFlag = async (flagName: FeatureFlagName) =>
  restClient.request<BaseResponse<UserFlagResponse[]>>(`/api/v1/admin/feature_flags/${flagName}/users`);

export const adminCreateUserFeatureFlag = (flagName: FeatureFlagName, userId: string, active: boolean) =>
  restClient.request(`/api/v1/admin/feature_flags/${flagName}/users/${userId}`, {
    method: 'POST',
    data: {
      active
    }
  });

export const adminToggleUserFeatureFlag = (flagName: FeatureFlagName, userId: string, active: boolean) =>
  restClient.request(`/api/v1/admin/feature_flags/${flagName}/users/${userId}`, {
    method: 'PATCH',
    data: {
      active
    }
  });

export const adminDeleteUserFeatureFlag = (flagName: FeatureFlagName, userId: string) =>
  restClient.request(`/api/v1/admin/feature_flags/${flagName}/users/${userId}`, {
    method: 'DELETE'
  });
